import { StyledOptions } from '@emotion/styled';

export function preventForwardTheseProps(...nonForwardProps: string[]): StyledOptions['shouldForwardProp'] {
  return (prop): boolean => {
    return !nonForwardProps.includes(prop);
  };
}
